import classNames from 'classnames'
import { ForwardedRef, forwardRef } from 'react'
import { Venue } from 'types/model'

import { H1 } from '@elements/headings'
import { Link } from '@elements/link'
import { imageOptimize } from '@utils/images'

export const VenuePageBanner = forwardRef(function VenuePageBanner(
  { venue, large = false }: { venue: Venue; large?: boolean },
  ref: ForwardedRef<HTMLDivElement>
) {
  const bannerSrc = imageOptimize(venue.primaryImage?.filename, {
    w: '1400',
    q: '80',
  })
  const logoSrc = imageOptimize(venue.logo, { q: '80' })

  return (
    <div
      ref={ref}
      className={classNames(
        'w-screen relative bg-center bg-cover bg-no-repeat parallax-background',
        {
          'h-[296px] sm:h-[448px]': large,
          'h-[156px] sm:h-[216px]': !large,
        }
      )}
      style={{ backgroundImage: `url(${bannerSrc})` }}
    >
      {bannerSrc && <div className="absolute w-full h-full inset-0 bg-stone-900/[.6]"></div>}
      {logoSrc ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center w-full h-full m-auto space-y-6">
          <div className="max-w-[216px] max-h-[72px] sm:max-w-[300px] sm:max-h-[156px] flex items-center justify-center">
            {logoSrc && (
              <Link href={`/v/${venue.slug}`} className="contents">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  alt={venue.name}
                  src={logoSrc}
                  className="w-auto h-auto max-w-full max-h-full"
                />
              </Link>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center w-full h-full p-3">
          <Link
            href={`/v/${venue.slug}`}
            className="contents !text-foreground dark:!text-dark-foreground"
          >
            <H1 className="text-center sm:heading-3xl">{venue.name}</H1>
          </Link>
        </div>
      )}
    </div>
  )
})
